ScoreTrekBattle.Tournament.Series = {};
